import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Slide,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';
import Iconify from '../common/iconify.component';
import ListChannelRulesets from './list-channel-rulesets.component';
import StyledDialogActions from '../../theme/dialogActionStyles';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const OverviewRulesets = ({ title, onCancel, formSubmitted }) => {
  const [processing, setProcessing] = useState(false);

  return (
    <Dialog
      open
      aria-labelledby="add-dialog-title"
      aria-describedby="add-dialog-description"
      TransitionComponent={Transition}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle id="add-dialog-title">{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onCancel}
        size="small"
        sx={{
          position: 'absolute',
          right: 10,
          top: 15,
          color: (theme) => theme.palette.grey[500],
        }}
        disabled={formSubmitted}
      >
        <Iconify icon="ic:outline-close" />
      </IconButton>

      <DialogContent dividers id="add-dialog-description">
        <ListChannelRulesets
          processing={processing}
          setProcessing={setProcessing}
        />
      </DialogContent>

      {processing && (
        <StyledDialogActions sx={{ justifyContent: 'center' }}>
          <Typography variant="body2" color="red">
            Do not close this window as channel assignment/scheduling is
            running. If closed, the assignment/scheduling will stop running.
          </Typography>
        </StyledDialogActions>
      )}
    </Dialog>
  );
};

OverviewRulesets.propTypes = {
  title: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  formSubmitted: PropTypes.bool.isRequired,
};

export default OverviewRulesets;
